import { BaseService } from "./BaseService";

const LegajoColaboradorService = {
  async subirDocumento(data) {
    const respuesta = await BaseService.put("/v2/legajo/upload-desde-colaborador", data);
    return respuesta.data;
  }
};
export default LegajoColaboradorService;
